import axios from 'axios';

const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const configuredBaseUrl = process.env.REACT_APP_API_URL;
const baseURL = isLocalHost
  ? (configuredBaseUrl && /localhost|127\.0\.0\.1/.test(configuredBaseUrl) ? configuredBaseUrl : 'http://localhost:4000/api')
  : (configuredBaseUrl || '/api');

const api = axios.create({ baseURL });
const appBasePath = process.env.PUBLIC_URL || '';
const licenseSetupPath = `${appBasePath}/license-setup`;
const appBaseSegment = String(appBasePath).replace(/^\/+|\/+$/g, '');
const appIdentity = `${window.location.hostname}${appBaseSegment ? `/${appBaseSegment}` : ''}`.toLowerCase();

api.defaults.headers.common['X-App-Identity'] = appIdentity;

// Add a response interceptor to handle licensing errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;
    const isLicenseError = status === 402 || (status === 403 && code === 'DOMAIN_MISMATCH');

    if (isLicenseError) {
      // Redirect to license setup if not already there
      if (!window.location.pathname.includes('/license-setup')) {
        window.location.href = licenseSetupPath;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
